/**
 * 初始化语言调试工具
 */
export const initLanguageDebug = (): void => {
  // 添加全局调试函数
  (window as any).debugLanguage = {
    getCurrentLanguage: () => {
      const language = localStorage.getItem('language');
      const manualSelection = localStorage.getItem('language_manual_selection');
      return { language, manualSelection };
    },
    
    setLanguage: (lang: string) => {
      if (!['en', 'vn', 'pl', 'it'].includes(lang)) {
        console.error('Invalid language. Use "en", "vn", "pl", or "it"');
        return;
      }
      localStorage.setItem('language', lang);
      localStorage.setItem('language_manual_selection', 'true');
    },
    
    clearLanguageSettings: () => {
      localStorage.removeItem('language');
      localStorage.removeItem('language_manual_selection');
    },
    
    getI18nInstance: () => {
      return (window as any).globalI18n;
    }
  };
};